import * as React from "react"

function Hours(props: Readonly<React.SVGProps<SVGSVGElement>>) {
    return (
        <svg
            width={86}
            height={85}
            viewBox="0 0 86 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M38.246 27.167v17.39a4.78 4.78 0 002.315 4.063l14.744 8.742c1.7.993 3.874.426 4.867-1.228.992-1.701.472-3.875-1.229-4.867l-13.562-8.08V27.12c-.047-1.89-1.654-3.497-3.591-3.497-1.938 0-3.544 1.607-3.544 3.544zM85.5 30.711V5.714c0-2.127-2.552-3.166-4.017-1.654l-8.41 8.411A42.576 42.576 0 0039.001.185C19.202 1.98 2.9 17.905.726 37.705A42.529 42.529 0 0085.17 47.817c.331-2.835-1.89-5.292-4.725-5.292-2.363 0-4.348 1.748-4.631 4.064-2.032 16.491-16.256 29.25-33.314 29.014-17.532-.237-32.322-15.027-32.606-32.606C9.61 24.568 24.59 9.447 42.971 9.447c9.12 0 17.39 3.733 23.391 9.687l-9.876 9.876c-1.512 1.512-.473 4.064 1.654 4.064h24.997A2.34 2.34 0 0085.5 30.71z"
                fill="#88BD3D"
            />
        </svg>
    )
}

export default Hours